<template>
  <div>
  {{ serverLocation }}
  </div>
</template>

<script>
export default {
  name: 'system-location',
  computed: {
    currentServer () {
      const servers = this.$store.getters['servers/data'](this.$store.dispatch)
      return servers.find(s => s.self) || {}
    },

    serverLocation () {
      const {location_id: locationId} = this.currentServer
      if (!locationId) {
        return '-'
      }
      const location = this.$store.getters['locations/findById'](locationId, this.$store.dispatch)

      const {name, zip, city, street} = location
      return `${name}, ${zip} ${city}, ${street}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// SystemLocation.vue?5bdb71d2